import {
    GET_8_MINUTE_RULE_CHART, GET_ACCESSIBLE_ACCOUNTS,
    GET_APPOINTMENT_STATUS_LIST,
    GET_BODY_PART_LIST,
    GET_CASE_STATUS_LIST,
    GET_COMMUNICATION_MODE_TYPE_LIST,
    GET_CONCUSSION_FILE_TYPES,
    GET_CONSULTATION_DURATION_LIST, GET_DOCUMENT_FILE_TYPES, GET_DOCUMENT_LIST,
    GET_EMPLOYMENT_STATUS_LIST, GET_FACILITY_LIST,
    GET_GENDER_LIST, GET_HEIGHT_UNITS,
    GET_INJURY_TYPE_LIST,
    GET_LANGUAGE_LIST,
    GET_MEDICAL_HISTORY_OPTIONS_LIST,
    GET_MEDICAL_RECORD_DOCUMENT_TYPES,
    GET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST,
    GET_PHONE_TYPE_LIST,
    GET_PROGRESS_REPORT_STATS_LIST,
    GET_REFERRAL_TYPE_LIST,
    GET_RELATIONSHIP_LIST,
    GET_SOCIAL_MEDIA_PLATFORM_LIST,
    GET_SURGICAL_HISTORY_OPTIONS_LIST, GET_WEIGHT_UNITS,
    SET_8_MINUTE_RULE_CHART, SET_ACCESSIBLE_ACCOUNTS,
    SET_APPOINTMENT_STATUS_LIST,
    SET_BODY_PART_LIST,
    SET_CASE_STATUS_LIST,
    SET_COMMUNICATION_MODE_TYPE_LIST,
    SET_CONCUSSION_FILE_TYPES,
    SET_CONSULTATION_DURATION_LIST, SET_DOCUMENT_FILE_TYPES, SET_DOCUMENT_LIST,
    SET_EMPLOYMENT_STATUS_LIST, SET_FACILITY_LIST,
    SET_GENDER_LIST, SET_HEIGHT_UNITS,
    SET_INJURY_TYPE_LIST,
    SET_LANGUAGE_LIST,
    SET_MEDICAL_HISTORY_OPTIONS_LIST,
    SET_MEDICAL_RECORD_DOCUMENT_TYPES,
    SET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST,
    SET_PAYMENT_MODES,
    SET_PHONE_TYPE_LIST,
    SET_PROGRESS_REPORT_STATS_LIST,
    SET_REFERRAL_TYPE_LIST,
    SET_RELATIONSHIP_LIST,
    SET_SOCIAL_MEDIA_PLATFORM_LIST,
    SET_SURGICAL_HISTORY_OPTIONS_LIST, SET_WEIGHT_UNITS
} from "../actions/static-data.action";
import {IActionModel} from "../../shared/models/action.model";
import {ICommonType} from "../../shared/models/static-data.model";
import {IConcussionFileType, IMedicalRecordDocumentType} from "../../shared/models/common.model";

export interface IStaticDataReducerState {
    statusList: ICommonType[],
    medicalStatusList: ICommonType[],
    isConsultationDurationListLoading: boolean,
    isConsultationDurationListLoaded: boolean,
    consultationDurationList: any[],
    isGenderListLoading: boolean,
    isGenderListLoaded: boolean,
    genderList: any[],
    isCaseStatusLoading: boolean,
    isCaseStatusLoaded: boolean,
    caseStatusList: any[],
    isEmploymentStatusListLoading: boolean,
    isEmploymentStatusListLoaded: boolean,
    employmentStatusList: any[],
    isPhoneTypeListLoading: boolean,
    isPhoneTypeListLoaded: boolean,
    phoneTypeList: any[],
    isLanguageListLoading: boolean,
    isLanguageListLoaded: boolean,
    languageList: any[],
    isRelationshipListLoading: boolean,
    isRelationshipListLoaded: boolean,
    relationshipList: any[],
    isMedicalHistoryOptionsListLoading: boolean,
    isMedicalHistoryOptionsListLoaded: boolean,
    medicalHistoryOptionsList: any[],
    isSurgicalHistoryOptionsListLoading: boolean,
    isSurgicalHistoryOptionsListLoaded: boolean,
    surgicalHistoryOptionsList: any[],
    isMusculoskeletalHistoryOptionsListLoading: boolean,
    isMusculoskeletalHistoryOptionsListLoaded: boolean,
    musculoskeletalHistoryOptionsList: any[],
    isSocialMediaPlatformListLoading: boolean,
    isSocialMediaPlatformListLoaded: boolean,
    socialMediaPlatformList: any[],
    isReferralTypeListLoading: boolean,
    isReferralTypeListLoaded: boolean,
    referralTypeList: any[],
    isCommunicationModeTypeListLoading: boolean,
    isCommunicationModeTypeListLoaded: boolean,
    communicationModeTypeList: any[],
    isBodyPartListLoading: boolean,
    isBodyPartListLoaded: boolean,
    bodyPartList: any[],
    isInjuryTypeListLoading: boolean,
    isInjuryTypeListLoaded: boolean,
    injuryTypeList: any[],
    isProgressReportStatListLoading: boolean,
    isProgressReportStatListLoaded: boolean,
    progressReportStatList: any[],
    isEightMinuteRuleChartLoading: boolean,
    isEightMinuteRuleChartLoaded: boolean,
    eightMinuteRuleChart: any[],
    isConcussionFileTypesLoading: boolean,
    isConcussionFileTypesLoaded: boolean,
    concussionFileTypes: IConcussionFileType[],
    isMedicalRecordDocumentTypesLoading: boolean,
    isMedicalRecordDocumentTypesLoaded: boolean,
    medicalRecordDocumentTypes: IMedicalRecordDocumentType[],
    isAppointmentStatusListLoading: boolean,
    isAppointmentStatusListLoaded: boolean,
    isAccessibleAccountsLoading: boolean,
    isAccessibleAccountsLoaded: boolean,
    accessibleAccounts: any[],
    appointmentStatusList: any[],
    paymentModes?: any[],
    isDocumentFileTypesListLoading: boolean,
    isDocumentFileTypesListLoaded: boolean,
    documentFileTypeList: any[],
    isFacilityListLoading: boolean,
    isFacilityListLoaded: boolean,
    facilityList: any[],
    isDocumentTypeListLoaded: boolean,
    isDocumentTypeListLoading: boolean,
    documentTypeList: any[],

    isPhysicalActivityFrequencyLoaded: boolean;
    isPhysicalActivityFrequencyLoading: boolean;
    physicalActivityFrequencyList: any[];

    isPhysicalActivityIntensityLoaded: boolean;
    isPhysicalActivityIntensityLoading: boolean;
    physicalActivityIntensityList: any[];

    isPhysicalActivityFrequencyForHeartRateImpactLoaded: boolean;
    isPhysicalActivityFrequencyForHeartRateImpactLoading: boolean;
    physicalActivityFrequencyForHeartRateImpactList: any[];

    isPhysicalActivityExerciseCapacityLoaded: boolean;
    isPhysicalActivityExerciseCapacityLoading: boolean;
    physicalActivityExerciseCapacityList: any[];

    isPhysicalActivityTypesLoaded: boolean;
    isPhysicalActivityTypesLoading: boolean;
    physicalActivityTypesList: any[];


    isWeightUnitsLoaded: boolean;
    isWeightUnitsLoading: boolean;
    weightUnitsList: any[];

    isHeightUnitsLoaded: boolean;
    isHeightUnitsLoading: boolean;
    heightUnitsList: any[];

}

const initialData: IStaticDataReducerState = {
    isConsultationDurationListLoading: false,
    isConsultationDurationListLoaded: false,
    consultationDurationList: [],
    isGenderListLoading: false,
    isGenderListLoaded: false,
    genderList: [],
    isCaseStatusLoading: false,
    isCaseStatusLoaded: false,
    caseStatusList: [],
    isEmploymentStatusListLoading: false,
    isEmploymentStatusListLoaded: false,
    employmentStatusList: [],
    isPhoneTypeListLoading: false,
    isPhoneTypeListLoaded: false,
    phoneTypeList: [],
    isLanguageListLoading: false,
    isLanguageListLoaded: false,
    languageList: [],
    isRelationshipListLoading: false,
    isRelationshipListLoaded: false,
    relationshipList: [],
    isMedicalHistoryOptionsListLoading: false,
    isMedicalHistoryOptionsListLoaded: false,
    medicalHistoryOptionsList: [],
    isSurgicalHistoryOptionsListLoading: false,
    isSurgicalHistoryOptionsListLoaded: false,
    surgicalHistoryOptionsList: [],
    isMusculoskeletalHistoryOptionsListLoading: false,
    isMusculoskeletalHistoryOptionsListLoaded: false,
    musculoskeletalHistoryOptionsList: [],
    isSocialMediaPlatformListLoading: false,
    isSocialMediaPlatformListLoaded: false,
    socialMediaPlatformList: [],
    isReferralTypeListLoading: false,
    isReferralTypeListLoaded: false,
    referralTypeList: [],
    isCommunicationModeTypeListLoading: false,
    isCommunicationModeTypeListLoaded: false,
    communicationModeTypeList: [],
    isBodyPartListLoading: false,
    isBodyPartListLoaded: false,
    bodyPartList: [],
    isInjuryTypeListLoading: false,
    isInjuryTypeListLoaded: false,
    injuryTypeList: [],
    statusList: [
        {
            code: 'all',
            title: "All"
        },
        {
            code: true,
            title: "Active"
        },
        {
            code: false,
            title: "Inactive"
        }
    ],
    medicalStatusList: [],
    isProgressReportStatListLoading: false,
    isProgressReportStatListLoaded: false,
    progressReportStatList: [],
    isEightMinuteRuleChartLoading: false,
    isEightMinuteRuleChartLoaded: false,
    eightMinuteRuleChart: [],
    isConcussionFileTypesLoading: false,
    isConcussionFileTypesLoaded: false,
    concussionFileTypes: [],
    isMedicalRecordDocumentTypesLoading: false,
    isMedicalRecordDocumentTypesLoaded: false,
    medicalRecordDocumentTypes: [],
    appointmentStatusList: [],
    isAppointmentStatusListLoading: false,
    isAppointmentStatusListLoaded: false,
    paymentModes: [],
    isAccessibleAccountsLoading: false,
    isAccessibleAccountsLoaded: false,
    accessibleAccounts: [],
    isDocumentFileTypesListLoading: false,
    isDocumentFileTypesListLoaded: false,
    documentFileTypeList: [],
    isFacilityListLoading: false,
    isFacilityListLoaded: false,
    facilityList: [],
    isDocumentTypeListLoaded: false,
    isDocumentTypeListLoading: false,
    documentTypeList: [],

    isPhysicalActivityFrequencyLoaded: false,
    isPhysicalActivityFrequencyLoading: false,
    physicalActivityFrequencyList: [],

    isPhysicalActivityIntensityLoaded: false,
    isPhysicalActivityIntensityLoading: false,
    physicalActivityIntensityList: [],

    isPhysicalActivityFrequencyForHeartRateImpactLoaded: false,
    isPhysicalActivityFrequencyForHeartRateImpactLoading: false,
    physicalActivityFrequencyForHeartRateImpactList: [],

    isPhysicalActivityExerciseCapacityLoaded: false,
    isPhysicalActivityExerciseCapacityLoading: false,
    physicalActivityExerciseCapacityList: [],

    isPhysicalActivityTypesLoaded: false,
    isPhysicalActivityTypesLoading: false,
    physicalActivityTypesList: [],

    isWeightUnitsLoaded: false,
    isWeightUnitsLoading: false,
    weightUnitsList: [],

    isHeightUnitsLoaded: false,
    isHeightUnitsLoading: false,
    heightUnitsList: []
};

const StaticDataReducer = (state = initialData, action: IActionModel): IStaticDataReducerState => {
    switch (action.type) {
        case GET_WEIGHT_UNITS:
            return {...state, isWeightUnitsLoading: true};

        case SET_WEIGHT_UNITS:
            return {
                ...state,
                isWeightUnitsLoading: false,
                isWeightUnitsLoaded: true,
                weightUnitsList: action.payload.weightUnits,
            };

        case GET_HEIGHT_UNITS:
            return {...state, isHeightUnitsLoading: true};

        case SET_HEIGHT_UNITS:
            return {
                ...state,
                isHeightUnitsLoading: false,
                isHeightUnitsLoaded: true,
                heightUnitsList: action.payload.heightUnits,
            };
        case 'GET_PHYSICAL_ACTIVITY_FREQUENCY':
            return {...state, isPhysicalActivityFrequencyLoading: true};

        case 'SET_PHYSICAL_ACTIVITY_FREQUENCY':
            return {
                ...state,
                isPhysicalActivityFrequencyLoading: false,
                isPhysicalActivityFrequencyLoaded: true,
                physicalActivityFrequencyList: action.payload.physicalActivityFrequencyList,
            };

        case 'GET_PHYSICAL_ACTIVITY_INTENSITY':
            return {...state, isPhysicalActivityIntensityLoading: true};

        case 'SET_PHYSICAL_ACTIVITY_INTENSITY':
            return {
                ...state,
                isPhysicalActivityIntensityLoading: false,
                isPhysicalActivityIntensityLoaded: true,
                physicalActivityIntensityList: action.payload.physicalActivityIntensityList,
            };

        case 'GET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT':
            return {...state, isPhysicalActivityFrequencyForHeartRateImpactLoading: true};

        case 'SET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT':
            return {
                ...state,
                isPhysicalActivityFrequencyForHeartRateImpactLoading: false,
                isPhysicalActivityFrequencyForHeartRateImpactLoaded: true,
                physicalActivityFrequencyForHeartRateImpactList: action.payload.physicalActivityFrequencyForHeartRateImpactList,
            };

        case 'GET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY':
            return {...state, isPhysicalActivityExerciseCapacityLoading: true};

        case 'SET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY':
            return {
                ...state,
                isPhysicalActivityExerciseCapacityLoading: false,
                isPhysicalActivityExerciseCapacityLoaded: true,
                physicalActivityExerciseCapacityList: action.payload.physicalActivityExerciseCapacityList,
            };

        case 'GET_PHYSICAL_ACTIVITY_TYPES':
            return {...state, isPhysicalActivityTypesLoading: true};

        case 'SET_PHYSICAL_ACTIVITY_TYPES':
            return {
                ...state,
                isPhysicalActivityTypesLoading: false,
                isPhysicalActivityTypesLoaded: true,
                physicalActivityTypesList: action.payload.physicalActivityTypesList,
            };


        case GET_CONSULTATION_DURATION_LIST:
            state = {
                ...state,
                isConsultationDurationListLoading: true,
                isConsultationDurationListLoaded: false,
            };
            return state;
        case SET_CONSULTATION_DURATION_LIST:
            state = {
                ...state,
                isConsultationDurationListLoading: false,
                isConsultationDurationListLoaded: true,
                consultationDurationList: action.payload.consultationDurationList
            };
            return state;
        case GET_GENDER_LIST:
            state = {
                ...state,
                isGenderListLoading: true,
                isGenderListLoaded: false,
            };
            return state;
        case SET_GENDER_LIST:
            state = {
                ...state,
                isGenderListLoading: false,
                isGenderListLoaded: true,
                genderList: action.payload.genderList
            };
            return state;
        case GET_LANGUAGE_LIST:
            state = {
                ...state,
                isLanguageListLoading: true,
                isLanguageListLoaded: false,
            };
            return state;
        case SET_LANGUAGE_LIST:
            state = {
                ...state,
                isLanguageListLoading: false,
                isLanguageListLoaded: true,
                languageList: action.payload.languageList
            };
            return state;
        case GET_EMPLOYMENT_STATUS_LIST:
            state = {
                ...state,
                isEmploymentStatusListLoading: true,
                isEmploymentStatusListLoaded: false,
            };
            return state;
        case SET_EMPLOYMENT_STATUS_LIST:
            state = {
                ...state,
                isEmploymentStatusListLoading: false,
                isEmploymentStatusListLoaded: true,
                employmentStatusList: action.payload.employmentStatusList
            };
            return state;
        case GET_PHONE_TYPE_LIST:
            state = {
                ...state,
                isPhoneTypeListLoading: true,
                isPhoneTypeListLoaded: false,
            };
            return state;
        case SET_PHONE_TYPE_LIST:
            state = {
                ...state,
                isPhoneTypeListLoading: false,
                isPhoneTypeListLoaded: true,
                phoneTypeList: action.payload.phoneTypeList
            };
            return state;
        case GET_RELATIONSHIP_LIST:
            state = {
                ...state,
                isRelationshipListLoading: true,
                isRelationshipListLoaded: false,
            };
            return state;
        case SET_RELATIONSHIP_LIST:
            state = {
                ...state,
                isRelationshipListLoading: false,
                isRelationshipListLoaded: true,
                relationshipList: action.payload.relationshipList
            };
            return state;
        case GET_MEDICAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isMedicalHistoryOptionsListLoading: true,
                isMedicalHistoryOptionsListLoaded: false,
            };
            return state;
        case SET_MEDICAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isMedicalHistoryOptionsListLoading: false,
                isMedicalHistoryOptionsListLoaded: true,
                medicalHistoryOptionsList: action.payload.medicalHistoryOptionsList
            };
            return state;
        case GET_SURGICAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isSurgicalHistoryOptionsListLoading: true,
                isSurgicalHistoryOptionsListLoaded: false,
            };
            return state;
        case SET_SURGICAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isSurgicalHistoryOptionsListLoading: false,
                isSurgicalHistoryOptionsListLoaded: true,
                surgicalHistoryOptionsList: action.payload.surgicalHistoryOptionsList
            };
            return state;
        case GET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isMusculoskeletalHistoryOptionsListLoading: true,
                isMusculoskeletalHistoryOptionsListLoaded: false,
            };
            return state;
        case SET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST:
            state = {
                ...state,
                isMusculoskeletalHistoryOptionsListLoading: false,
                isMusculoskeletalHistoryOptionsListLoaded: true,
                musculoskeletalHistoryOptionsList: action.payload.musculoskeletalHistoryOptionsList
            };
            return state;
        case GET_SOCIAL_MEDIA_PLATFORM_LIST:
            state = {
                ...state,
                isSocialMediaPlatformListLoading: true,
                isSocialMediaPlatformListLoaded: false,
            };
            return state;
        case SET_SOCIAL_MEDIA_PLATFORM_LIST:
            state = {
                ...state,
                isSocialMediaPlatformListLoading: false,
                isSocialMediaPlatformListLoaded: true,
                socialMediaPlatformList: action.payload.socialMediaPlatformList
            };
            return state;
        case GET_REFERRAL_TYPE_LIST:
            state = {
                ...state,
                isReferralTypeListLoading: true,
                isReferralTypeListLoaded: false,
            };
            return state;
        case SET_REFERRAL_TYPE_LIST:
            state = {
                ...state,
                isReferralTypeListLoading: false,
                isReferralTypeListLoaded: true,
                referralTypeList: action.payload.referralTypeList
            };
            return state;
        case GET_COMMUNICATION_MODE_TYPE_LIST:
            state = {
                ...state,
                isCommunicationModeTypeListLoading: true,
                isCommunicationModeTypeListLoaded: false,
            };
            return state;
        case SET_COMMUNICATION_MODE_TYPE_LIST:
            state = {
                ...state,
                isCommunicationModeTypeListLoading: false,
                isCommunicationModeTypeListLoaded: true,
                communicationModeTypeList: action.payload.communicationModeTypeList
            };
            return state;
        case GET_BODY_PART_LIST:
            state = {
                ...state,
                isBodyPartListLoading: true,
                isBodyPartListLoaded: false,
            };
            return state;
        case SET_BODY_PART_LIST:
            state = {
                ...state,
                isBodyPartListLoading: false,
                isBodyPartListLoaded: true,
                bodyPartList: action.payload.bodyPartList
            };
            return state;
        case GET_INJURY_TYPE_LIST:
            state = {
                ...state,
                isInjuryTypeListLoading: true,
                isInjuryTypeListLoaded: false,
            };
            return state;
        case SET_INJURY_TYPE_LIST:
            state = {
                ...state,
                isInjuryTypeListLoading: false,
                isInjuryTypeListLoaded: true,
                injuryTypeList: action.payload.injuryTypeList
            };
            return state;

        case GET_DOCUMENT_FILE_TYPES:
            state = {
                ...state,
                isDocumentFileTypesListLoading: true,
                isDocumentFileTypesListLoaded: false
            }
            return state;
        case SET_DOCUMENT_FILE_TYPES:
            state = {
                ...state,
                isDocumentFileTypesListLoading: false,
                isDocumentFileTypesListLoaded: true,
                documentFileTypeList: action.payload.documentFileTypeList
            }
            return state;

        case GET_DOCUMENT_LIST:
            state = {
                ...state,
                isDocumentTypeListLoading: true,
                isDocumentTypeListLoaded: false
            }
            return state;
        case SET_DOCUMENT_LIST:
            state = {
                ...state,
                isDocumentTypeListLoading: false,
                isDocumentTypeListLoaded: true,
                documentTypeList: action.payload.documentTypeList
            }
            return state;

        case GET_FACILITY_LIST:
            state = {
                ...state,
                isFacilityListLoading: true,
                isFacilityListLoaded: false,
            }
            return state;

        case SET_FACILITY_LIST:
            state = {
                ...state,
                isFacilityListLoading: false,
                isFacilityListLoaded: false,
                facilityList: action.payload.facilityList
            }
            return state;

        case GET_CASE_STATUS_LIST:
            state = {
                ...state,
                isGenderListLoading: true,
                isCaseStatusLoaded: false
            }
            return state;
        case SET_CASE_STATUS_LIST:
            state = {
                ...state,
                isGenderListLoading: false,
                isCaseStatusLoaded: true,
                caseStatusList: action.payload.caseStatusList
            }
            return state;
        case GET_PROGRESS_REPORT_STATS_LIST:
            state = {
                ...state,
                isProgressReportStatListLoading: true,
                isProgressReportStatListLoaded: false
            }
            return state;
        case SET_PROGRESS_REPORT_STATS_LIST:
            state = {
                ...state,
                isProgressReportStatListLoading: false,
                isProgressReportStatListLoaded: true,
                progressReportStatList: action.payload.progressReportStatList
            }
            return state;
        case GET_8_MINUTE_RULE_CHART:
            state = {
                ...state,
                isEightMinuteRuleChartLoading: true,
                isEightMinuteRuleChartLoaded: false
            }
            return state;
        case SET_8_MINUTE_RULE_CHART:
            state = {
                ...state,
                isEightMinuteRuleChartLoading: false,
                isEightMinuteRuleChartLoaded: true,
                eightMinuteRuleChart: action.payload.eightMinuteRuleChart
            }
            return state;
        case GET_CONCUSSION_FILE_TYPES:
            state = {
                ...state,
                isConcussionFileTypesLoading: true,
                isConcussionFileTypesLoaded: false
            }
            return state;
        case SET_CONCUSSION_FILE_TYPES:
            state = {
                ...state,
                isConcussionFileTypesLoading: false,
                isConcussionFileTypesLoaded: true,
                concussionFileTypes: action.payload.concussionFileTypes
            }
            return state;
        case GET_MEDICAL_RECORD_DOCUMENT_TYPES:
            state = {
                ...state,
                isMedicalRecordDocumentTypesLoading: true,
                isMedicalRecordDocumentTypesLoaded: false
            }
            return state;
        case SET_MEDICAL_RECORD_DOCUMENT_TYPES:
            state = {
                ...state,
                isMedicalRecordDocumentTypesLoading: false,
                isMedicalRecordDocumentTypesLoaded: true,
                medicalRecordDocumentTypes: action.payload.medicalRecordDocumentTypes
            }
            return state;
        case GET_APPOINTMENT_STATUS_LIST:
            state = {
                ...state,
                isAppointmentStatusListLoading: true,
                isAppointmentStatusListLoaded: false
            }
            return state;
        case SET_APPOINTMENT_STATUS_LIST:
            state = {
                ...state,
                isAppointmentStatusListLoading: false,
                isAppointmentStatusListLoaded: true,
                appointmentStatusList: action.payload.appointmentStatusList
            }
            return state;
        case SET_PAYMENT_MODES:
            state = {
                ...state,
                paymentModes: action.payload.paymentModes
            };
            return state;
        case GET_ACCESSIBLE_ACCOUNTS:
            state = {
                ...state,
                isAccessibleAccountsLoading: true,
                isAccessibleAccountsLoaded: false
            }
            return state;
        case SET_ACCESSIBLE_ACCOUNTS:
            state = {
                ...state,
                isAccessibleAccountsLoading: false,
                isAccessibleAccountsLoaded: true,
                accessibleAccounts: action.payload.accessibleAccounts
            }
            return state;
        default:
            return state;
    }
};

export default StaticDataReducer;
